import get from 'lodash/get';
import set from 'lodash/set';
import sortBy from 'lodash/sortBy';
import { applicationTypes, applicationSubTypes } from 'constants/scripts';

export const parseBrandsFromSprout = (brands) => {
  const parsedBrandData = brands.map(({ id, name }) => {
    return {
      name,
      uuid: id
    };
  });
  return sortBy(parsedBrandData, ['name']);
};
export const parseSproutProducts = (data) => {
  const productsToParse = data.seedProductsByLegacyIds 
  || data.seedProductsByLocation?.nodes 
  || [data.seedProduct];
  
  const parsedProductsData = productsToParse.map(({
    updatedAt,
    cropId,
    name,
    legacyIds,
    isGeneric,
    brand,
    brandId,
    id,
    relativeMaturity
  }) => {
    const legacyId = Number(legacyIds.id);

    return {
      'updated-at': updatedAt,
      'crop-uuid': cropId,
      name,
      'legacy-id': legacyId,
      generic: isGeneric,
      'brand-name': brand.name,
      'brand-uuid': brandId,
      uuid: id,
      rm: {
        q: relativeMaturity?.value.toString(),
        u: relativeMaturity?.unit
      },
      id,
      brand: brand.name
    };
  });

  return sortBy(parsedProductsData, ['name']);
};

export const parseFertilizerSubstanceTypes = (rawSubstanceTypes) => {
  return rawSubstanceTypes.results.reduce((result, { id, name }) => {
    // only take the fertilizer types we need for now. should this be a selector instead?
    switch (name) {
      case 'Nitrogen':
      case 'Phosphorus':
      case 'Potassium':
        set(result, `byName.${name.toLowerCase()}`, id);
        set(result, `byUuid.${id}`, name.toLowerCase());
        break;
      case 'Calcium':
        // lime is actually calcium products greater than 20%, so switch this here
        set(result, `byName.lime`, id);
        set(result, `byUuid.${id}`, 'lime');
        break;
      default:
        break;
    }
    return result;
  }, {});
};
export const parseFertilityChemicalTypes = (rawChemicalTypes) => {
  const stuff = rawChemicalTypes.results.reduce((result, { id, code }) => {
    // only take the chemical types we need for now
    switch (code) {
      case 'commercial-fertilizer':
        set(result, `${applicationTypes.FERTILIZER}.chemicalTypeUuid`, id);
        break;
      case 'n-stabilizer': //'Nitrogen Stabilizer'
        set(result, `${applicationTypes.STABILIZER}.chemicalTypeUuid`, id);
        break;
      case 'herbicide':
        set(result, `${applicationSubTypes.HERBICIDE}.chemicalTypeUuid`, id);
        break;
      case 'insecticide':
        set(result, `${applicationSubTypes.INSECTICIDE}.chemicalTypeUuid`, id);
        break;
      case 'fungicide':
        set(result, `${applicationSubTypes.FUNGICIDE}.chemicalTypeUuid`, id);
        break;
      case 'growth-regulator':
        set(result, `${applicationSubTypes.GROWTHREGULATOR}.chemicalTypeUuid`, id);
        break;
      default:
        break;
    }
    return result;
  }, {});
  return stuff;
};

export const parseApplicationProducts = ({ applicationType, rawProducts }) => {
  switch (applicationType) {
    case applicationTypes.FERTILIZER:
    case applicationTypes.APPLICATION:
      return sortBy(get(rawProducts, 'results'), ['name']);
    case applicationTypes.SEED:
      return parseSproutProducts(rawProducts);
    case applicationTypes.STABILIZER:
      return sortBy(get(rawProducts, 'results'), ['name']);
    default:
      return [];
  }
};
